import { CSSProperties, PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const MediumText = (
  props: PropsWithChildren<{
    className?: string;
    size?: number;
    style?: CSSProperties;
  }>
): JSX.Element => (
  <span
    style={{
      ...props.style,
      fontSize: props.size || 14,
    }}
    className={cn(styles.mediumText, props.className)}
  >
    {props.children}
  </span>
);
